import { FC, useMemo } from 'react'

import RFFFields from '../../react-final-form-fields'
import { validateRequired, validateMaxSymbols, composeValidators } from '../../../../util/validation'
import { nameofFactory, getPlaceholderTextFromLabel } from '../../../../util'

import { TrainingTypeFormFieldsProps, ITrainingTypeValues } from './training-type-form-types'
import { useTrainingCategoriesQuery } from '../../../../services'
import HorizontalRule from '../../../horizontal-rule'

const validateMaxSymbols500 = validateMaxSymbols(500, 'Field must not exceed 500 characters')
const validateMaxSymbols100 = validateMaxSymbols(100, 'Field must not exceed 100 characters')

const nameof = nameofFactory<ITrainingTypeValues>()

const nameLabel = 'Name'
const objectivesLabel = 'Objectives'
const categoryLabel = 'Category'
const acReferenceLabel = 'AC Reference'
const defaultExpirationMonthsLabel = 'Default Expiration Months'
const sortOrderLabel = 'Sort Order'
const activeLabel = 'Active'

const TrainingTypeFormFields: FC<TrainingTypeFormFieldsProps> = props => {
  const { disabled } = props
  const { data: trainingCategories } = useTrainingCategoriesQuery({ activeOnly: true })
  const categoryOptions = useMemo(
    () =>
      trainingCategories?.map(category => ({
        label: category.displayName,
        value: category.id,
      })) ?? [],
    [trainingCategories],
  )

  return (
    <>
      <RFFFields.Input
        name={nameof('name')}
        label={nameLabel}
        placeholder={getPlaceholderTextFromLabel(nameLabel)}
        disabled={disabled}
        validate={composeValidators(validateRequired, validateMaxSymbols100)}
      />

      <RFFFields.Input
        name={nameof('objectives')}
        label={objectivesLabel}
        placeholder={getPlaceholderTextFromLabel(objectivesLabel)}
        disabled={disabled}
        validate={validateMaxSymbols500}
      />

      <RFFFields.Select
        name={nameof('trainingCategoryId')}
        label={categoryLabel}
        placeholder={'Select ' + categoryLabel}
        validate={validateRequired}
        disabled={disabled}
        options={categoryOptions}
      />

      <RFFFields.MaskedInput
        type="number"
        name={nameof('defaultExpirationMonths')}
        label={defaultExpirationMonthsLabel}
        placeholder={getPlaceholderTextFromLabel(defaultExpirationMonthsLabel)}
        disabled={disabled}
      />

      <RFFFields.Input
        name={nameof('acReference')}
        label={acReferenceLabel}
        placeholder={getPlaceholderTextFromLabel(acReferenceLabel)}
        disabled={disabled}
        validate={validateMaxSymbols100}
      />

      <RFFFields.MaskedInput
        type="number"
        name={nameof('sortOrder')}
        label={sortOrderLabel}
        placeholder={getPlaceholderTextFromLabel(sortOrderLabel)}
        disabled={disabled}
      />

      <RFFFields.Switch name={nameof('isActive')} label={activeLabel} onLabel="yes" offLabel="no" disabled={disabled} />

      <HorizontalRule />

      <RFFFields.DocumentUpload wrapperClassName="mb-0" name={nameof('documents')} disabled={disabled} parentType="TrainingType" />
    </>
  )
}

export default TrainingTypeFormFields
